import React from "react";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Bell, Plus } from "lucide-react";
import { MERCH, ASSETS, MERCH_AVAILABLE } from "../lib/content";
import { useCart } from "../lib/cart";

export const Merch = ({ onJoin }) => {
  const { add, setOpen } = useCart();

  const addMerch = (m) => {
    add(m, 1, "merch", m.price);
    toast.success(`${m.name} added to your bag.`);
    setOpen(true);
  };

  return (
    <section id="merch" data-testid="merch-section" className="relative py-24 md:py-36 px-5 md:px-10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-end mb-14">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember mb-4">Wear the Gremlin</p>
            <h2 className="font-display font-black uppercase tracking-tight text-cream text-5xl md:text-7xl leading-[0.9]">
              More than <span className="font-serif italic font-normal lowercase text-ember">beans</span>
            </h2>
            <p className="font-mono text-sm text-cream/75 mt-6 max-w-md leading-relaxed">
              {MERCH_AVAILABLE
                ? "Gremlin Coffee is a lifestyle in the making. Caps, tees and totes carrying the air-roasted badge. They're sold separately from the beans and ship in their own box."
                : "Gremlin Coffee is a lifestyle in the making. Caps, tees and totes carrying the air-roasted badge are in the works. Coffee Club members hear about the drop first."}
            </p>
            {!MERCH_AVAILABLE && (
              <button
                onClick={onJoin}
                data-testid="merch-notify-button"
                className="mt-7 inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest bg-ember text-void px-6 py-3.5 rounded-full font-medium hover:bg-emberDark transition-colors"
              >
                <Bell size={14} /> Get notified on drop
              </button>
            )}
          </div>
          <div className="relative rounded-lg overflow-hidden border border-white/10 group">
            <img src={ASSETS.merchMockup} alt="Gremlin merch" className="w-full h-[300px] object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-void/70 to-transparent" />
            <span className="absolute bottom-5 left-5 font-mono text-xs uppercase tracking-widest text-cream">
              Merch Collection {MERCH_AVAILABLE ? "· Live" : "· Coming Soon"}
            </span>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {MERCH.map((m, i) => (
            <motion.div
              key={m.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.07 }}
              data-testid={`merch-item-${m.id}`}
              className="group border border-white/10 rounded-lg p-6 bg-ash hover:border-ember/60 transition-colors duration-300 flex flex-col justify-between min-h-[200px]"
            >
              <div>
                <h3 className="font-display font-extrabold uppercase text-cream text-xl leading-tight">{m.name}</h3>
                <p className="font-mono text-[11px] text-cream/65 mt-1">{m.tag}</p>
              </div>
              <div className="flex items-center justify-between mt-5">
                <p className="font-mono text-ember text-sm">${m.price}</p>
                {MERCH_AVAILABLE ? (
                  <button
                    onClick={() => addMerch(m)}
                    data-testid={`merch-add-${m.id}`}
                    className="inline-flex items-center gap-1.5 bg-void border border-ember/40 text-ember font-mono text-[11px] uppercase tracking-widest px-3.5 py-2 rounded-full group-hover:bg-ember group-hover:text-void transition-colors duration-200"
                  >
                    <Plus size={13} /> Add
                  </button>
                ) : (
                  <span
                    data-testid={`merch-soon-${m.id}`}
                    className="font-mono text-[10px] uppercase tracking-widest text-cream/65 border border-white/15 px-3 py-1.5 rounded-full"
                  >
                    Soon
                  </span>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
